import { AssignCredit } from "~/components/CreditManagement/Assessment/AssignCredit"
import { FinancialAssessment } from "~/components/CreditManagement/Assessment/FinancialAssessment"
import { TransactionAssessment } from "~/components/CreditManagement/Assessment/TransactionAssessment"

export type CreditLimitAssessmentType = {
  form?: any
  isDisabled?: boolean
  isSubmitted?: boolean
}

export const CreditLimitAssessment = ({
  form,
  isDisabled = false,
  isSubmitted = false,
}) => {
  return (
    <>
      {/* <CreditSummaryHistory form={form} /> */}
      <FinancialAssessment
        form={form}
        isDisabled={isDisabled}
        isSubmitted={isSubmitted}
      />
      <TransactionAssessment
        form={form}
        isDisabled={isDisabled}
        isSubmitted={isSubmitted}
      />
      <AssignCredit
        form={form}
        isDisabled={isDisabled}
        isSubmitted={isSubmitted}
      />
    </>
  )
}
